import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { PersonLabels } from "@/domain/types/person";

export function usePersonLabels(): PersonLabels {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      roles: {
        admin: t("person.roles.admin"),
        employee: t("person.roles.employee"),
        promoter: t("person.roles.promoter"),
        investor: t("person.roles.investor"),
        auditor: t("person.roles.auditor"),
        representative: t("person.roles.representative"),
      },
      open: t("person.open"),
      openAria: (name: string) => t("person.open_aria", { name }),
    }),
    [t],
  );
}
